import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Trees } from "lucide-react";
import { toast } from "sonner";
import { useSiteSettings } from "@/contexts/SettingsContext";
import BrandLogo from "@/components/BrandLogo";

export default function RegisterPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();
  const { settings } = useSiteSettings();
  const tagline = settings?.register_tagline || (settings?.app_name ? `Créez votre compte ${settings.app_name}` : "Créez votre compte");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Minimum 6 caractères"); return; }
    setLoading(true);
    try { await register(email, password, name); toast.success("Compte créé!"); navigate("/"); }
    catch (err) { toast.error(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Erreur"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-12">
      <Card className="w-full max-w-md border border-zinc-200 rounded-2xl shadow-sm animate-fade-in" data-testid="register-card">
        <CardHeader className="text-center">
          <div className="mx-auto mb-2 flex items-center justify-center"><BrandLogo size="md" /></div>
          <CardTitle className="font-heading text-2xl font-bold">Inscription</CardTitle>
          <CardDescription>{tagline}</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="register-form">
            <div><Label htmlFor="name">Nom complet</Label><Input id="name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Votre nom" required className="mt-1" data-testid="register-name-input" /></div>
            <div><Label htmlFor="email">Email</Label><Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="votre@email.com" required className="mt-1" data-testid="register-email-input" /></div>
            <div><Label htmlFor="password">Mot de passe</Label><Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Minimum 6 caractères" required className="mt-1" data-testid="register-password-input" /></div>
            <Button type="submit" className="w-full bg-emerald-700 text-white hover:bg-emerald-800 rounded-xl" disabled={loading} data-testid="register-submit-btn">{loading ? "Inscription..." : "Créer mon compte"}</Button>
          </form>
        </CardContent>
        <CardFooter className="justify-center"><p className="text-sm text-zinc-500">Déjà un compte? <Link to="/login" className="text-emerald-600 hover:underline font-medium" data-testid="goto-login-link">Se connecter</Link></p></CardFooter>
      </Card>
    </div>
  );
}
